import React from 'react'

const MaterialTestingServicesSoil = () => {
  return (
    <section className="services-details pt-120 pb-120">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          {/*Start Services Details Content*/}
          <div className="col-xl-12 col-lg-12">
            <div className="services-details__content">
              <h3>Material Testing Services – Soil </h3>
              <p className="mb-30">
                Soil is a naturally occurring material with highly variable
                engineering properties that directly influence the performance
                and safety of civil and structural works. Soil Material Testing
                must figure out the physical, mechanical, and chemical
                characteristics of soil to ensure it is suitable for its
                intended engineering application.
              </p>
              <p className="mb-30">
                The requirement for standardized soil testing arose due to
                construction failures caused by improper soil choice, inadequate
                compaction, poor bearing capacity, and excessive settlement.
                International standards were proved to ensure uniform testing
                methods, accurate interpretation of results, and reliable
                comparison of soil performance across projects.
              </p>
              <p className="mb-30">
                Without proper soil material testing, construction projects face
                increased risks of structural distress, pavement failure,
                instability, and non-compliance with regulatory requirements.
              </p>
              <div className="content mt-40">
                <div className="text">
                  <h3 className="mb-4">Purpose and Engineering Importance</h3>
                  <p className="mb-30">
                    The primary purpose of soil material testing is to provide
                    quantitative data needed for design, construction control,
                    and quality assurance. This service enables engineers and
                    project stakeholders to:
                  </p>
                  <ul className="project-list">
                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Classifying soil for engineering use
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Evaluating soil strength, compressibility, and
                      permeability
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Verifying suitability of soil for foundations,
                      embankments, and backfilling
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Ensuring compliance with project specifications and
                      standards
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Controlling construction quality and performance
                    </li>
                  </ul>
                  <p className="mb-30">
                    From a commercial and risk-management perspective, soil
                    testing reduces uncertainty, supports optimized design, and
                    prevents costly remedial work.
                  </p>
                </div>
              </div>
              <div className="service-nr-list">
                <h3 className="mb-5">Our Services </h3>
                <p className="mb-30">
                  Pak Arab Inspection LTD. CO Company provides professional Soil Material
                  Testing services through standardized laboratory and
                  field-testing procedures. Our services support geotechnical
                  investigations, foundation design, earthworks, road
                  construction, and infrastructure projects.
                </p>
                <p className="mb-30">
                  Our testing is performed by trained technicians under the
                  supervision of qualified engineers, ensuring accuracy,
                  reliability, and compliance with international standards.
                </p>
              </div>
              <div className="service-nr-list">
                <h3 className="">Scope </h3>
                <h4 className="">
                  Our Soil Material Testing services typically include:
                </h4>
                <div className="row">
                  <div className="col-lg-4">
                    <h5>Index and Classification Tests</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Moisture Content
                        Determination.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Particle Size
                        Distribution (Sieve and Hydrometer Analysis).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Atterberg Limits (Liquid
                        Limit, Plastic Limit, Plasticity Index).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Soil Classification (USCS
                        / AASHTO).
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Compaction and Density Tests</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Standard Proctor and
                        Modified Proctor Tests.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Field Density Testing (As
                        Applicable).
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Strength and Compressibility Tests </h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Unconfined Compressive
                        Strength Test.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Direct Shear Test.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Triaxial Compression
                        Tests.
                      </li>

                      <li>
                        <i className="fal fa-check" /> One-Dimensional
                        Consolidation Test.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Chemical Tests (as required)</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Sulphate Content.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Chloride Content.
                      </li>

                      <li>
                        <i className="fal fa-check" /> pH Value.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Organic Content.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MaterialTestingServicesSoil